module.exports = __webpack_public_path__ + "img/bgIcon_7.00993217.png";